import axios from 'axios'
import store from '../../../store'

const setAttachment = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    const { bucket, code } = payload
    if ((bucket === undefined) || code === undefined) return false
    const response = await axios.get(`https://sync.gestaoclinic.com.br/list?bucket=${bucket}&MaxKeys=150&prefix=imagens/${code}`)
    // const attachment = response.data.Contents.map((item) => {
    //   arrayItems = item.Key.split('_')
    //   typeIcon = item.Key.split('.')
    //   return {
    //     path: item.Key,
    //     name: moment(arrayItems[1], 'DDMMYYYY').format('DD-MM-YYYY'),
    //     id: item.ETag,
    //     file: typeIcon[1],
    //     icon: 'a'
    //   }
    // })
    return resolve(commit('SET_ATTACHMENT', response))
  })
}

const setPatient = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    if (!payload) return false
    axios.get(`${process.env.URL}/my-clinic-new/patient/find-one`, {
      params: {
        patient: payload,
        customer: store.state.customer
      }
    }).then((response) => {
      // handle success
      const profileData = response.data.results.results.map((item) => {
        return {
          id: item.tbCodigo,
          name: item.tbNome,
          symbol: 'BTC',
          website_slug: 'spitzer.io',
          dateOfBirth: item.tbDtNasc,
          mobile: item.tbCelular,
          covenant: item.tbConvenio,
          email: item.tbEmail,
          city: item.tbCidade,
          addrees: item.tbEndereco,
          rg: item.tbRG,
          cpf: item.tbCPF,
          bucket: item.tbParametro || undefined
        }
      })
      resolve(commit('SET_PATIENT', profileData[0]))
    })
      .catch(err => {
        console.log(err)
        reject(err)
      })
      .then(function () {
        // always executed
      })
  })
}

export default {
  setPatient,
  setAttachment
}



// WEBPACK FOOTER //
// ./src/store/modules/patient/actions.js